import { Injectable, Injector } from "@angular/core";
import { AppContext, DataTypeInfo, Entity, FrameContext, Repository } from "@farris/devkit";

@Injectable()
export class BindingPathService {
  constructor(private injector: Injector, private appContext: AppContext, private repository: Repository<Entity>) { }
  /**
   * è·åç»ä»¶ä¸ä¸æçç»å®è·¯å¾
   * @param frameContext ç»ä»¶ä¸ä¸æ
   * @returns 
   */
  public getBindingPathsByFrameContext(frameContext: FrameContext): string[] {
    return frameContext && frameContext.viewModel && frameContext.viewModel.bindingPath && frameContext.viewModel.bindingPath.split('/').filter(p => p) || null;
  }
  /**
   * éè¿BEè¡¨åè·åbindingPath
   * @param dataTypeInfo 
   * @param tableName 
   * @param paths 
   * @param level
   * @returns 
   */
  public getBindingPathsByTableName(dataTypeInfo: DataTypeInfo, tableName: string, paths: string[] = [], level: number = 0): string[] {
    level++;
    if (dataTypeInfo.entityInfo && (dataTypeInfo.entityInfo.nodeCode === tableName || dataTypeInfo.entityInfo.originalCode === tableName)) {
      if (level !== 1) {
        paths.push(dataTypeInfo.entityInfo.nodeCode);
      }
      return paths;
    }
    const props = Array.from(dataTypeInfo.propInfoMap.values()).filter(p => p.typeInfo);
    if (props.length < 1) {
      paths = [];
      return paths;
    }
    if (dataTypeInfo.entityInfo) {
      if (level !== 1) {
        paths.push(dataTypeInfo.entityInfo.nodeCode);
      }
    }

    for (let idx = 0; idx < props.length; idx++) {
      const dataTypeInfo = props[idx].typeInfo;
      const path = this.getBindingPathsByTableName(dataTypeInfo, tableName, paths, level);
      if (!path || path.length < 1) {
        continue;
      } else {
        paths = paths.concat(path);
        return paths;
      }
    }
    return null;
  }
  /**
   * è·åå±æ§è·¯å¾ä¸­çç»å®è·¯å¾
   * @param paths paths
   * @param entityTypeInfo 
   * @returns 
   */
  public getBindingPathsByPath(paths: string[] | string, entityTypeInfo: DataTypeInfo): string[] {
    let nodeCodes = [];
    if (typeof paths === 'string') {
      paths = paths.split('/').filter(p => p);
    }
    paths = paths.concat([]);
    while (paths.length > 0) {
      const dataPropInfo = entityTypeInfo.getPropInfoByPath(paths);
      if (dataPropInfo.group === 'List') {
        nodeCodes = paths;
        break;
      }
      paths.pop();
    }
    return nodeCodes;
  }
  /**
   * è·åå±æ§è·¯å¾ä¿¡æ¯
   * @param path å±æ§è·¯å¾
   * @returns 
   */
  public getPathInfo(path: string): { bindingPath: string, propertyName: string, bindingPaths: string[], propertyNames: string[] } {
    const paths = path.split('/').filter(p => p);
    // è·åæå¤§å®ä½å±çº§ï¼å¶ä½ä¸ºå±æ§ï¼ç®åå±æ§ãudtãå³èãå³èåµå¥å³èï¼
    const entityPath = this.getBindingPathsByPath(paths, this.repository.entityTypeInfo);
    const propertyName = paths.slice(entityPath.length).join('/');
    return { bindingPath: entityPath.join('/'), propertyName, bindingPaths: entityPath, propertyNames: propertyName.split('/').filter(p => p) };
  }
}